import React from "react";

const faqs = [
  {
    q: "Is Skhool.in free of cost for schools?",
    a: "Yes. Skhool.in offers a free plan for eligible schools, with paid plans based on student strength and advanced needs.",
  },
  {
    q: "Why choose an AI school management system in India?",
    a: "India is rapidly moving digital. An AI-ready school platform helps automate daily operations, improve communication, and reduce manual effort for staff.",
  },
  {
    q: "Which users can log in to Skhool.in?",
    a: "School admins, teachers, students, and parents can use role-based access in web and mobile experiences.",
  },
  {
    q: "Does Skhool.in support attendance, fees, and exam results?",
    a: "Yes. It supports attendance workflows, fee configuration and reminders, examinations, marks entry, and result publishing.",
  },
  {
    q: "Can schools launch their website with Skhool.in?",
    a: "Yes. Schools can manage banners, pages, notices, and SEO-friendly website content from the platform.",
  },
];

const cardStyle = {
  background: "#ffffff",
  border: "1px solid rgba(148,163,184,0.24)",
  borderRadius: 6,
  padding: "0.9rem",
};

const SeoFaqSection = () => {
  return (
    <section id="faq" style={{ maxWidth: 1160, margin: "0 auto", padding: "2.2rem 1rem" }}>
      <div style={{ textAlign: "center", marginBottom: "1rem" }}>
        <h2 style={{ margin: 0, fontSize: "1.75rem", color: "#0f172a" }}>Frequently Asked Questions</h2>
        <p style={{ margin: "0.4rem 0 0", color: "#475569" }}>
          Everything schools ask before choosing an AI school management system.
        </p>
      </div>

      <div style={{ display: "grid", gap: "0.7rem", gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))" }}>
        {faqs.map((item) => (
          <article key={item.q} style={cardStyle}>
            <h3 style={{ margin: "0 0 0.35rem", color: "#0f172a", fontSize: "1rem" }}>{item.q}</h3>
            <p style={{ margin: 0, color: "#475569", fontSize: "0.9rem", lineHeight: 1.5 }}>{item.a}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default SeoFaqSection;
